import React, { Suspense, useState } from 'react';
import { actualizarEstadoCompania, companiaSeguro } from '../models/companiaSeguro';
import { actualizarEstadoCompaniaService } from '../service/servicesCompaniaSeguro';
import { useToast } from '../../../../hooks/useToast';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ActionMenu, { Action } from '../../../../components/ui/materialui/actionMenu';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import { usePermissions } from '../../../../components/auth/ProtectedRoute';
import { getCurrentUsername } from '../../../../services/userRolesService';

interface IProps {
  companiaSeguro: companiaSeguro;
  control: any;
  setCompaniaEditar: React.Dispatch<React.SetStateAction<companiaSeguro | undefined>>;
  setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccionesCompania: React.FC<IProps> = ({ companiaSeguro, control, setCompaniaEditar, setModalDetalle }) => {

  const { hasPermission } = usePermissions();
  const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);

  const [modalConfirmacion, setModalConfirmacion] = useState({
    show: false,
    title: '',
    message: '',
    metodo: () => {
    },
  })

  const { addToast } = useToast();

  async function EliminarCompania(companiaSeguro: companiaSeguro) {

    let dataRequest: actualizarEstadoCompania = {
      id: companiaSeguro.id,
      activo: false,
      modificadoPor: getCurrentUsername()
    }

    const response = await actualizarEstadoCompaniaService(dataRequest);

    if (response.status === StatusCode.NoContent) {
      setModalConfirmacion({ ...modalConfirmacion, show: false })
      control.fetchData();

      addToast({
        mostrar: true,
        titulo: 'Confirmación',
        tipo: 'Success',
        mensaje: 'Compañía de seguros eliminada correctamente'
      });

    } else {   

      setModalConfirmacion({ ...modalConfirmacion, show: false })
    }
  }

  const handleEditarClick = () => {

    setCompaniaEditar({
      ...companiaSeguro,
      modificadoPor: null,
      fechaModificacion: null,
    });

    setModalDetalle(true)
  }

  const handleEliminarClick = () => {

    setModalConfirmacion({
      show: true,
      title: "Eliminar compañía de seguros",
      message: `¿Estás seguro de eliminar la compañía de seguros: ${companiaSeguro.nombre}?`,
      metodo: () => {
        EliminarCompania(companiaSeguro)
      },
    })

  }

   const actions: Action[] = [];  

    if (puedeEditar) {
      actions.push({
        label: "Editar",
        icon: <EditIcon fontSize="small" />,
        onClick: handleEditarClick
      });

      actions.push({
        label: "Eliminar",
        icon: <DeleteIcon fontSize="small" />,
        onClick: handleEliminarClick
      });
    }

  return (
    <>
      <ActionMenu actions={actions} />
      <ConfirmationModal
        onHide={() => setModalConfirmacion({ ...modalConfirmacion, show: false })}
        onConfirm={modalConfirmacion.metodo}
        show={modalConfirmacion.show}
        title={modalConfirmacion.title}
        message={modalConfirmacion.message}
      />
    </>
  );
};

export default AccionesCompania;
